import { routing } from "@/i18n/routing";

export const publicRoutes = [
  "/",
  "/learning-tools",
  "/learning-tools/quizzes",
  "/features/classroom",
  "/features/quiz",
  "/features/chess",
  "/features-hub/times-table",
  "/features-hub/addition-facts",
  "/features-hub/subtraction-facts",
  "/features-hub/division-facts",
  "/features-hub/alphabet",
  "/features-hub/nato-alphabet",
  "/schools",
  "/terms-conditions",
  "/the-team",
  "/videos",
  "/contact",
  "/education",
  "/education/browse",
] as const;

const publicRouteSet = new Set<string>(publicRoutes);

export function isPublicContentPath(pathname: string | null): boolean {
  if (!pathname) return false;

  const [locale, ...segments] = pathname.split("/").filter(Boolean);
  if (!routing.locales.some((supported) => supported === locale)) return false;

  const route = `/${segments.join("/")}`;
  return publicRouteSet.has(route) || (segments[0] === "education" && segments.length === 2);
}
